module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Fortsett slik","subtitle":"Fyll ditt ukentlige hjerte med daglige hjernedates","footerText":"Complete the building blocks of life"},"en":{"title":"Keep it up","subtitle":"Fill up your weekly heart with daily brain dates","footerText":"Complete the building blocks of life"}}')
  delete Component.options._Ctor
}
